export default __webpack_public_path__ + "static/media/corpadminmgr.75a8339c.svg";